import * as React from 'react';

export const Spinner = (): JSX.Element => {
    return <div className="c-spinner">
        <div className="c-spinner__bounce1"> </div>
        <div className="c-spinner__bounce2"> </div>
        <div className="c-spinner__bounce3"> </div>
    </div>
}
